import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-def28b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-overlay" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"q-spinner\" data-v-def28b08><div class=\"q-rect1\" data-v-def28b08></div><div class=\"q-rect2\" data-v-def28b08></div><div class=\"q-rect3\" data-v-def28b08></div><div class=\"q-rect4\" data-v-def28b08></div><div class=\"q-rect5\" data-v-def28b08></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]




export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentLoader',
  props: ['loading'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3, 512)), [
    [_vShow, __props.loading]
  ])
}
}

})